import script from "./ChatUserOrderItem.vue?vue&type=script&setup=true&lang=jsx"
export * from "./ChatUserOrderItem.vue?vue&type=script&setup=true&lang=jsx"

import "./ChatUserOrderItem.vue?vue&type=style&index=0&id=8757507c&lang=scss"

const __exports__ = script;

export default __exports__